import EventEmitter from 'eventemitter3'
import { Channel } from '../../app-api-config'
import { GRIDTYPE, REQUEST_STATUS } from '../../enum'
import RowList from './row-model'
import { GridModel, RowListInfo } from './grid-model'
import { ItemNode } from "./ItemNode"
import { Log } from '@lightningjs/sdk'
import RowItem from './RowItem/RowItem'
import { Helper } from '../../helper'

export type FocusInfo = {
  focusRow: number
  foucsItem: number
}

export default class GridViewModel extends EventEmitter {


  gridModel: GridModel | null
  channelInfo: Channel | ItemNode
  focusInfo: FocusInfo
  uiList: any[] = []
  isMlp = false
  mlpId = ''
  reloadOnInit = false
  type: GRIDTYPE
  parentGrid: null | GridViewModel = null
  childGrid: null | GridViewModel = null

  constructor(channelInfo: Channel | ItemNode, isMlp = false, id = '') {
    super()
    this.channelInfo = channelInfo
    this.gridModel = new GridModel(this.channelInfo, isMlp)
    this.focusInfo = {
      focusRow: 0,
      foucsItem: 0,
    }
    this.isMlp = isMlp
    this.mlpId = id
    this.type = GRIDTYPE.GRID
  }

  getFocusInfo(): FocusInfo {
    return {
      ...this.focusInfo
    }
  }

  resetGrid(): void {
    this.destroy();
    this.uiList = [];
    this.reloadOnInit = true;
  }

  changeFocus(focusInfo: FocusInfo) {
    this.focusInfo = {
      ...focusInfo
    }
    if (this.uiList.length > 0) {
      this.uiList[this.focusInfo.focusRow].data.focusItem = focusInfo.foucsItem
    }
    Log.info('GridViewModel: changeFocus: ' + this.mlpId, this.focusInfo.focusRow, this.uiList[this.focusInfo.focusRow].data.focusItem)
    this._dispatchEvent('focused')
  }

  add(rowList: RowList, index = 0, uiRow?: any) {
    this.gridModel.add(rowList, index)
    if (uiRow) {
      this.uiList.splice(index, 0, uiRow)
      this.uiList.map((item, index) => {
        item.data.rowUIIndex = index
      })
      let oldFocus = this.getFocusInfo()
      oldFocus.focusRow = oldFocus.focusRow >= index ? oldFocus.focusRow + 1 : oldFocus.focusRow
      this.focusInfo = {
        focusRow: oldFocus.focusRow,
        foucsItem: oldFocus.foucsItem
      }
      this.emit('add', uiRow , index)
    }
  }

  remove(index = -1) {
    this.gridModel.remove(index)
    this.uiList.splice(index, 1)
    this.uiList.map((item, index) => {
      item.data.rowUIIndex = index
    })
    let oldFocus = this.getFocusInfo()
    oldFocus.focusRow = oldFocus.focusRow > index ? oldFocus.focusRow - 1 : oldFocus.focusRow
    this.emit('remove', index)
  }

  update(rowList: RowList, index = 0, uiRow?: any) {
    this.gridModel.update(rowList, index)
    this.uiList[index] = uiRow
    this.uiList.map((item, itemIndex) => {
      item.data.rowUIIndex = itemIndex
    })
    this.emit('update', uiRow, index)
  }

  _dispatchEvent(eventName: string) {
    this.emit(eventName)
  }

  _init(): Promise<any> {
    return this.gridModel.fetchInitialRows().then((status) => {
      this._dispatchEvent('loaded')
    })
  }

  _updateUiRow() {

  }

  _updateRowNodes(nodeInfo:ItemNode, action:any) {
    let findNodeId = nodeInfo.node_id;
    let type = 'post';
    let idType = 'node_id';
    if(nodeInfo.type == 'listoflist') {
        //fix for nodes of listoflist where some times it s node_id or id. from api
        // XFIN - 837
        type = nodeInfo.type;
        if(nodeInfo.node_id == '') {
            findNodeId = nodeInfo.id;
            idType = 'id'
        }
    }
    this.gridModel.categoryList.map((rowItemInfo:RowListInfo)=>{
        const rowItem:RowList = rowItemInfo.rowList;
        if(rowItem.initFetcingStatus == REQUEST_STATUS.OK) {
            rowItem.videos.map((vodInfo: ItemNode)=>{
                if(vodInfo) {
                    let id = vodInfo.node_id;
                    if(type == 'listoflist' && idType == 'id') {
                        id = vodInfo.id;
                    }
                    if(findNodeId == id) {
                        vodInfo.blockItem = (action == 'block' ? true : false)
                    }
                }
            })
        }
    })
  }

  async fetchInitialRows() {
    await this.gridModel.fetchInitialRows()
  }

  async fetchMoreRows(pgNo: number) {
    return await this.gridModel.fetchPage(pgNo)
  }

  checkAndLoadMoreRows(focusIndex: number) {
    const { rowIndex } = this.uiList[focusIndex].data.item
    const stIndx = rowIndex
    let endIndx = stIndx + this.gridModel.limit
    if (endIndx > this.uiList.length) {
      endIndx = this.uiList.length
    }
    for (let i = stIndx; i < endIndx; i++) {
      const { rowList, rowPage } = this.uiList[i].data.item
      if (rowList.initFetcingStatus == REQUEST_STATUS.NONE) {
        this.fetchMoreRows(rowPage)
      }
    }
  }

  createGridListUI(reload = false) {
    if (this.uiList.length > 0 || reload) {
      return this.uiList
    }
    const uiList = []
    const items: RowList[] = []
    let count = 0
    this.gridModel.categoryList.map((item, index) => {
      const { rowList, rowIndex, rowPage } = item
      if (rowList.initFetcingStatus !== REQUEST_STATUS.FAIL) {
        const rowStyle = Helper.getRowStyle(rowList)
        uiList.push({
          h: rowStyle.row_height,
          autoResizeHeight:false,
          autoResizeWidth:false,
          collision:true,
          type: RowItem,
          data: {
            item: item,
            rowUIIndex: count,
            focusItem: 0
          },
          title: this.type == GRIDTYPE.VIDEOPLAYLIST ? rowList.playlistRowName : rowList.name
        })
        count++
      }
    })
    this.uiList = uiList
    return this.uiList
  }
  /* Fix for XFIN-1213 */
  getFocusedItem() {
    if(this.uiList && this.uiList.length > 0){
      return this.uiList[this.focusInfo.focusRow].data.item.rowList.videos[this.focusInfo.foucsItem]!
    }
    return null
  }
  /* Fix for XFIN-1213 */
  getRowAt(index: number): RowList | undefined {
    if (!this.uiList || this.uiList.length == 0) return undefined
    const { rowList, rowPage } = this.uiList[index].data.item
    return rowList
  }

  getUiRowAt(index: number): any | undefined {
    if (!this.uiList || this.uiList.length == 0) return undefined
    return this.uiList[index]
  }

  getRowByName(rowName: string): RowList | undefined {
    return this.uiList.find(i => i.data.item.rowList.name.toLowerCase().indexOf(rowName.toLowerCase()) >= 0)
  }

  getRowKey() {
    let uiRow = this.getUiRowAt(this.focusInfo.focusRow)
    let keys = uiRow.data.item.rowList.keys
    return keys
  }

  async getItemAt(rowIndex: number, itemIndex: number): Promise<ItemNode> {
    const rowList: RowList = this.uiList[rowIndex].data.item.rowList
    const pageNo: number = rowList.getPageNoFromItemIndex(itemIndex)
    await rowList.fetchMoreVideos(pageNo)
    Log.info('GVM: getItemAt: ', rowList.videos[itemIndex])
    return rowList.videos[itemIndex]!
  }

  _getRowItemLength(rowIndex: number) {
    return this.uiList[rowIndex].data.item.rowList.videosCount
  }

  _isRowsLoaded() {
    if(!this.gridModel.categoryList || this.gridModel.categoryList.length == 0) {
        return false
    } else {
        return true
    }
  }

  async getNextItem(tempFocus:FocusInfo|null = null): Promise<ItemNode | null> {
    let nextFocusRow = this.focusInfo.focusRow
    let nextItemIndex = this.focusInfo.foucsItem
    if (tempFocus !== null) {
      nextFocusRow = tempFocus.focusRow
      nextItemIndex = tempFocus.foucsItem
    }
    let vodItem!: ItemNode
    nextItemIndex++;
    if (nextItemIndex >= this._getRowItemLength(this.focusInfo.focusRow)) {
      nextFocusRow++
      nextItemIndex = 0
      if (nextFocusRow >= this.uiList.length) {
        nextFocusRow = 0
        if (this.isMlp) {
          return null
        }
      }
    }
    vodItem = await this.getItemAt(nextFocusRow, nextItemIndex)
    if(vodItem.actiontype == 'live') {
        nextFocusRow++
        nextItemIndex = 0
        vodItem = await this.getItemAt(nextFocusRow, nextItemIndex)
    }
    if (tempFocus == null) {
      this.changeFocus({
        focusRow: nextFocusRow,
        foucsItem: nextItemIndex,
      })
    }
    Log.info('GVM: getNextItem: ', vodItem)
    return vodItem
  }

  async getPrevItem(): Promise<ItemNode | null> {
    let prevFocusRow = this.focusInfo.focusRow
    let prevItemIndex = this.focusInfo.foucsItem
    let vodItem!: ItemNode
    const parentGridType = (this.parentGrid && this.parentGrid.type) || ''
    prevItemIndex--;
    if (prevItemIndex < 0) {
      prevFocusRow--
      if (prevFocusRow >= 0) {
        prevItemIndex = this._getRowItemLength(prevFocusRow) - 1
      } else {
        if (this.isMlp && parentGridType !== GRIDTYPE.SEARCH) {
          return null
        } else {
          prevFocusRow = 0
          prevItemIndex = 0
        }
      }
    }
    vodItem = await this.getItemAt(prevFocusRow, prevItemIndex)
    if(vodItem.actiontype == 'live') {
        prevFocusRow--
        if(prevFocusRow < 0) {
          prevFocusRow = this.focusInfo.focusRow
          prevItemIndex = 0
        } else{
          prevItemIndex = this._getRowItemLength(prevFocusRow)-1
        }
        vodItem = await this.getItemAt(prevFocusRow, prevItemIndex)
    }
    this.changeFocus({
      focusRow: prevFocusRow,
      foucsItem: prevItemIndex,
    })
    Log.info('GVM: getPrevItem: ', vodItem)
    return vodItem
  }

  async findAndLoadSeasonEpisode(seasonNo: string, episodeNo: string) {
    let seasonIndex = 0
    let episodeIndex = 0
    let rowList!: RowList
    let _episodeId = episodeNo
    if (!isNaN(parseInt(seasonNo))) {
        this.uiList.map((item, index) => {
          //updated for the issue some times the show.php response from api season_no is returned as "na"
          // XFIN-792
          if(!item.data.item.rowList.season || item.data.item.rowList.season == 'na' || item.data.item.rowList.season == '') {
              rowList = item.data.item.rowList
              if(item.data.item.rowList.videos && item.data.item.rowList.videos.length >0 && item.data.item.rowList.videos[0].season == seasonNo){
                  seasonIndex = item.data.rowUIIndex
                  rowList = item.data.item.rowList
              }
          } else if (item.data.item.rowList.season == seasonNo) {
            seasonIndex = item.data.rowUIIndex
            rowList = item.data.item.rowList
          }
        })
       //Log.info('findAndLoadSeasonEpisode: Seasons', seasonNo, episodeNo, rowList.season, seasonIndex, episodeIndex)
      this.checkAndLoadMoreRows(seasonIndex)

      await rowList.fetchMoreVideos(0)
      let indx = -1
      let exit = false
      while (!exit) {
        indx++
        let vodItem: ItemNode = rowList.videos[indx]!
        if (!vodItem) {
          await rowList.fetchMoreVideos(Math.floor(indx / rowList.limit))
        }
        vodItem = rowList.videos[indx]!
       Log.info('findAndLoadSeasonEpisode: ', indx, episodeNo, _episodeId, episodeIndex, Math.floor(indx / rowList.limit), vodItem.episode)
        if (!isNaN(parseInt(episodeNo))) {
          if (vodItem.episode == episodeNo) {
            episodeIndex = indx
            exit = true
          }
          if (indx >= rowList.videosCount - 1) {
            exit = true
          }
        } else {
          exit = true
        }
      }
    }
    this.changeFocus({ focusRow: seasonIndex, foucsItem: episodeIndex })
  }

  destroy() {
    this.removeAllListeners()
    // if(this.parentGrid) {
    //   this.parentGrid.childGrid = null
    //   this.parentGrid = null      
    // }
    this.gridModel.destroy()
    //this.gridModel = null
  }

  updateItemLikeStatus(likeVal: any, refocus: boolean = true) {
    const vodInfo: ItemNode = this.getFocusedItem();
    let findNodeId = vodInfo.node_id;
    let idType = 'node_id';

    if (vodInfo.feed_type === 'category' || !vodInfo.node_id) {
        findNodeId = vodInfo.id;
        idType = 'id';
    }
    const grids = [this, this.parentGrid, this.childGrid];
    grids.forEach(grid => {
        grid?.gridModel?.categoryList.forEach((rowItemInfo: RowListInfo) => {
            const rowList = rowItemInfo.rowList;
            if (rowList.initFetcingStatus === REQUEST_STATUS.OK) {
                rowList.videos.forEach((item: ItemNode) => {
                    const itemId = idType === 'id' ? item.id : item.node_id;
                    if (findNodeId == itemId) {
                        item.likedislike = likeVal;
                    }
                });
            }
        });
    });
    if(refocus) {
      this._dispatchEvent('focused');
    }
  }
}
